import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../../common/api-url-helper';
import { UserErrorMessages } from '../../../constants/error-messages';
import { CommonLabelConstant, commonLabelConstants, UserLabelConstants } from '../../../constants/label-constants';
import { CommonService } from '../../../services/common/common.service';
import { StorageService, StorageKey } from '../../../services/storage/storage.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../services/user-service/user.service';
import { DirtyCheckComponent } from '../../dirty-check/dirty-check.component';

@Component({
  selector: 'app-add-edit-user-dialog',
  templateUrl: './add-edit-user.component.html',
  styleUrls: ['./add-edit-user.component.scss'],
})

export class AddEditUserDialogComponent implements OnInit {
  commonConstants = CommonLabelConstant;
  labelConstants = UserLabelConstants;
  errorMessages = UserErrorMessages;
  isLoading: boolean = false;
  roleId!: any;
  decryptRoleId: any;
  isEdit: boolean = false;
  IsProfile: boolean = false;
  id: string = '';
  isRedirectFromCompany: boolean = false;
  companyId!: number;
  @Input() addUserForm!: FormGroup;
  imageSrc!: string;
  countryList: any = [];
  countryId: any;
  stateId: any;
  roleList: any = [];
  editedUserDetails: any;
  submitted: boolean = false;
  IsPreviewTrue: boolean = false;
  loginId: any;
  logoUrlFile: any;
  companyList: any = [];
  uploadedUrl: any;
  userId: string = '';
  roleName: string = '';
  isToShowCompany: boolean = false;

  constructor(
    private readonly toastr: ToastrService,
    private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly fb: FormBuilder,
    private readonly storageService: StorageService,
    public modalServices: NgbActiveModal,
    private readonly userService: UserService,
    private readonly modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.decryptRoleId = this.storageService.getValue('roleId');
    let decryptUserId = this.storageService.getValue('userId');
    this.roleId = this.commonService.Decrypt(this.decryptRoleId);
    this.roleName = this.storageService.getValue('userRole');
    this.userId = this.commonService.Decrypt(decryptUserId);
    if (this.id != '0') {
      this.fetchUserDetails();
    }
    if (this.isRedirectFromCompany) {
      this.getUserRoleList(this.isRedirectFromCompany)
    }
    else {
      this.getUserRoleList(this.isRedirectFromCompany);
    }
    this.initializeForm();
    this.isView(this.isEdit);
    this.getCompanyList(this.isRedirectFromCompany);
    this.loginId = this.commonService.Decrypt(this.storageService.getValue(StorageKey.userId));
  }

  initializeForm() {
    this.addUserForm = this.fb.group({
      UserImage: [''],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      Role: [null, Validators.required],
      Email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=.{1,30}@)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
      PhoneNumber: ['', [Validators.required, Validators.minLength(10)]],
      IsActive: [true],
      CompanyId: ['', Validators.required]
    });
  }

  isView(isEdit: boolean) {
    if (isEdit) {
      this.addUserForm.disable();
    } else {
      this.addUserForm.enable();
    }
  }

  onClose(type: string) {
    if (this.addUserForm.dirty) {
      const modalRef = this.modalService.open(DirtyCheckComponent);
      modalRef.componentInstance.title = commonLabelConstants.dirtyCheck;
      modalRef.componentInstance.message = commonLabelConstants.Dirtycheckconfirmation;
      modalRef.result.then((result) => {
        if (result === 'confirm') {
          this.modalServices.close(type);
        }
      }, (reason) => {
      });
    }
    else {
      this.modalServices.close(type);
    }
    this.isToShowCompany = false;
  }

  @HostListener('window:beforeunload', ['$event'])
  public canDeactivated(event: BeforeUnloadEvent): void {
    if (this.addUserForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }

  get GetUserFormControls() {
    return this.addUserForm.controls;
  }

  onFileChanged(event: any): true | undefined {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      let file: any;
      let ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          break;
        default:
          (<HTMLInputElement>document.getElementById('uploaduserLogo')).value = "";
          this.toastr.error('Please select only JPG,JPEG or PNG image.')
          return true;
      }
      const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
      if (event.target.files[0].size > maxSize) {
        this.toastr.error('File size must be less than 5 MB.');
        return true;
      }

      reader.onload = (e: ProgressEvent<FileReader>) => {
        file = e.target;
        (document.getElementById('userLogoName')!).innerHTML = event.target.files[0].name;
        (document.getElementById('userLogoPreview')!).setAttribute('src', file!.result as string);
        this.uploadedUrl = file!.result as string;
      };
      reader.readAsDataURL(event.target.files[0]);
      this.logoUrlFile = event.target.files[0];
    } else {
      if(this.uploadedUrl == null){
        (document.getElementById("userLogoPreview")!).setAttribute("src", "assets/images/Thumnail.jpg");
        this.logoUrlFile = null;
        (document.getElementById('userLogoName')!).innerHTML = '';
        this.uploadedUrl = null;
  
        (<HTMLInputElement>document.getElementById('uploaduserLogo')).value = '';
        this.addUserForm.controls['UserImage'].setValue('');
      }
    }
    return undefined;
  }
  getFormValidity(): boolean {
    return this.addUserForm.valid;
  }
  getFormValues() {
    return this.addUserForm.value;
  }

  submitUserForm() {
    this.submitted = true;
    if (this.addUserForm.valid) {
      this.addUserForm.get('Email')?.enable();
      this.isLoading = true;
      this.addUserForm.get('Role')?.enable();
      this.addUserForm.get('CompanyId')?.enable();
      let api = this.api.apiUrl.User.AddEditUser;
      const formData = new FormData();
      formData.append('UserId', this.id || '0');
      formData.append('RoleId', this.addUserForm.controls['Role'].value);
      formData.append('EmailId', this.addUserForm.value.Email);
      formData.append('Firstname', this.addUserForm.value.FirstName);
      formData.append('Lastname', this.addUserForm.value.LastName);
      formData.append('UserPhotoFile', this.logoUrlFile);
      formData.append("UserPhoto", this.addUserForm.value.UserImage ? this.addUserForm.value.UserImage?.split('/')?.at(-1) : '');
      formData.append('MobileNumber', this.addUserForm.value.PhoneNumber);
      formData.append('CompanyId', this.addUserForm?.value?.CompanyId ? this.addUserForm?.value?.CompanyId : 0);
      formData.append('IsActive', 'true');
      formData.append('appURL', window.location.origin + '/');
      this.commonService.doPost(api, formData).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success(response.message);
            if (this.id == this.loginId && this.uploadedUrl != undefined && this.uploadedUrl != null) {
              localStorage.setItem('userImage', this.uploadedUrl ? this.uploadedUrl : '');
              this.commonService.setUserImage(this.uploadedUrl);
            }
            else {
              localStorage.setItem('userImage', this.addUserForm.value.UserImage ? this.addUserForm.value.UserImage : '');
              this.commonService.setUserImage(this.addUserForm.value.UserImage ? this.addUserForm.value.UserImage : '');
            }
            if (this.id && this.id == this.loginId) {
              this.userService.setUserName(this.addUserForm.value.FirstName + ' ' + this.addUserForm.value.LastName);
              this.storageService.setValue('userName', this.addUserForm.value.FirstName + ' ' + this.addUserForm.value.LastName);
            }
            this.isLoading = false;
            this.modalServices.close('save');
            this.isToShowCompany = false;
          } else {
            this.toastr.error(response.message);
            this.isLoading = false;
          }
        },
        error: (error) => {
          console.log(error);
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    }
  }

  getCountryList() {
    let api = this.api.apiUrl.country.GetCountryList;
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.countryList = response.data;
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  handleImageError() {
    this.imageSrc = '../../../assets/img/default-user-profile.svg';
  }

  getUserRoleList(bindvalue: boolean) {
    let api = this.api.apiUrl.Role.GetRoleDropDwon;
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          if (bindvalue) {
            this.roleList = response.data.filter((role: any) => role.roleID === 2);
            if (this.roleList.length > 0) {
              this.addUserForm.get('Role')?.setValue(this.roleList[0].roleID);
              this.addUserForm.get('Role')?.disable();
            }
          }
          else {
            this.roleList = response.data;
          }
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  fetchUserDetails() {
    this.isToShowCompany = true;
    this.isLoading = true;
    let api = this.api.apiUrl.User.GetUserById.replace('{Id}', this.id);
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        this.editedUserDetails = response.data;
        if (this.editedUserDetails.userId == this.userId) {
          this.addUserForm.controls['Role'].disable();
          this.addUserForm.controls['IsActive'].disable();
        }
        if (this.editedUserDetails.roleId == 1) {
          this.isToShowCompany = false;
          this.addUserForm.get('CompanyId')?.clearValidators();
          this.addUserForm.get('CompanyId')?.updateValueAndValidity();
        }
        if (response.data.photo) {
          (document.getElementById("userLogoPreview")!).setAttribute("src", response.data.photo);
        }
        else {
          (document.getElementById("userLogoPreview")!).setAttribute("src", "../../../assets/img/default-user-profile.svg");
        }
        this.imageSrc = this.editedUserDetails.userImage;
        this.addUserForm.patchValue({
          Image: this.editedUserDetails.photo,
          FirstName: this.editedUserDetails.firstName,
          LastName: this.editedUserDetails.lastName,
          Role: this.editedUserDetails.roleId,
          Email: this.editedUserDetails.emailId,
          PhoneNumber: this.editedUserDetails.mobileNumber,
          CompanyId: this.editedUserDetails.companyId,
          IsActive: this.editedUserDetails.isActive,
          UserImage: this.editedUserDetails.photo
        });
        this.imageSrc = this.editedUserDetails.photo;
        this.addUserForm.get('Email')?.disable();
        this.isLoading = false;
        if (this.IsPreviewTrue) {
          this.addUserForm.disable();
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  getCompanyList(isRedirectFromCompany: boolean) {
    let api = this.api.apiUrl.Company.GetCompanyListWithoutPagination;
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          if (isRedirectFromCompany && this.companyId) {
            this.companyList = response.data.filter((company: any) => company.id === this.companyId);
            this.getCompanyListDropDown({ roleID: 2 });
          } else {
            this.companyList = response.data;
          }
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  getCompanyListDropDown(event: any) {
    const roleId = event.roleID;
    const companyIdControl = this.addUserForm.get('CompanyId');
    switch (roleId) {
      case 1:
        this.isToShowCompany = false;
        companyIdControl?.clearValidators();
        companyIdControl?.updateValueAndValidity();
        break;
      case 2:
      case 3:
      case 4:
        this.isToShowCompany = true;
        if (Number(this.roleId) == 1) {
          companyIdControl?.setValidators([Validators.required]);
          companyIdControl?.updateValueAndValidity();
          if (this.isRedirectFromCompany) {
            this.addUserForm.get('CompanyId')?.setValue(this.companyId);
            this.addUserForm.get('CompanyId')?.disable();
          }
        }
        if (Number(this.roleId) != 1) {
          companyIdControl?.clearValidators();
          companyIdControl?.updateValueAndValidity();
        }
        break;
      default:
        this.isToShowCompany = false;
        break;
    }
  }
}